module.exports = __webpack_public_path__ + "static/media/fortinet.02b5986c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/fortinet.png
// module id = 165
// module chunks = 0